var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#13A9B2",
    fillRule: "evenodd",
    d: "M2 26a2 2 0 1 1 0-4h.832C4.375 18.468 7.9 16 12 16a9.995 9.995 0 0 1 8.587 4.873C21.57 20.316 22.753 20 24 20c1.247 0 2.43.316 3.413.873A9.995 9.995 0 0 1 36 16c4.1 0 7.625 2.468 9.168 6H46a2 2 0 1 1 0 4c0 5.523-4.477 10-10 10s-10-4.477-10-10c0-.337.017-.671.05-1H26c0-.407-.79-1-2-1s-2 .593-2 1h-.05c.033.329.05.663.05 1 0 5.523-4.477 10-10 10S2 31.523 2 26Zm10 6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Zm30-6a6 6 0 1 1-12 0 6 6 0 0 1 12 0Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/glasses.0d91005c86ca74e04e65ab91fc6d7a06.svg";
export { ForwardRef as ReactComponent };